import styles from './styles.module.scss';
import { Menu, MenuItem, Dropdown } from 'components-antd';
import { Icons } from 'pages/Profile/components/icons';

const PortfolioItemActionsMenu = ({
  clientId,
  addressId,
  isArchived,
  handlePortfolioItemArchive,
}) => {
  const menu = (
    <Menu className={styles.portfolioItemActionsMenuDD} onClick={(e) => {}}>
      <MenuItem
        key={'view'}
        icon={<Icons variant={Icons.ARCHIVE} color={'#FF576D'} />}
        className={styles.menuItem}
        onClick={() => handlePortfolioItemArchive(clientId, addressId, !isArchived)}
      >
        <span className={styles.menuItemSpan}>{isArchived ? 'Unarchive' : 'Archive'}</span>
      </MenuItem>
    </Menu>
  );

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Dropdown
        overlay={menu}
        placement="bottomRight"
        overlayClassName={styles.portfolioItemActionsMenu}
        trigger={['click']}
      >
        <div className={styles.outerContainer}>
          <div className={styles.container}>
            <Icons variant={Icons.HAMBURGER} className={styles.hbIcon} />
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default PortfolioItemActionsMenu;
